import * as React from "react";
import {
  previewListingQuality,
  type ListingQualityPreviewPayload,
  type ListingQualityResult,
} from "@/app/api/auth-client";

/** Debounced POST /auth/me/listing-quality/preview for create/edit forms. */
export function useListingQualityPreview(
  payload: ListingQualityPreviewPayload | null,
  enabled = true
): { result: ListingQualityResult | null; loading: boolean; error: string | null } {
  const [result, setResult] = React.useState<ListingQualityResult | null>(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);

  const payloadKey = React.useMemo(
    () => (payload ? JSON.stringify(payload) : ""),
    [payload]
  );

  React.useEffect(() => {
    if (!enabled || !payload || !payload.title?.trim()) {
      setResult(null);
      setLoading(false);
      setError(null);
      return;
    }
    let cancelled = false;
    setLoading(true);
    setError(null);
    const timer = window.setTimeout(() => {
      previewListingQuality(payload)
        .then((res) => {
          if (!cancelled) setResult(res);
        })
        .catch((e: unknown) => {
          if (!cancelled) {
            setError(e instanceof Error ? e.message : "Não foi possível calcular a qualidade");
            setResult(null);
          }
        })
        .finally(() => {
          if (!cancelled) setLoading(false);
        });
    }, 400);
    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [enabled, payloadKey, payload]);

  return { result, loading, error };
}
